import { AnimationFactory, AnimationPlayer } from '@angular/animations';
import { Component, ElementRef, Renderer2 } from '@angular/core';

@Component({
    selector: 'ms-slide',
    template: '<ng-content />',
})
export class SlideComponent {
    private animationPlayer?: AnimationPlayer;

    constructor(
        private element: ElementRef,
        private renderer: Renderer2,
    ) {}

    animate(animation: AnimationFactory): void {
        if (this.animationPlayer) {
            this.animationPlayer.finish();
            // this.animationPlayer.destroy(); // ??? should both be used ?
        }

        this.animationPlayer = animation.create(this.element.nativeElement);

        this.animationPlayer.play();
    }

    moveOutside(): void {
        this.renderer.setStyle(this.element.nativeElement, 'transform', 'translateX(-100%)');
    }
}
